import { Root } from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import {
  forwardRef,
  type ElementRef,
  type ComponentPropsWithoutRef,
} from 'react';

import { cn } from '@/lib/utils';

const labelVariants = cva(
  'leading-none text-vestgrey-100 peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

const Label = forwardRef<
  ElementRef<typeof Root>,
  ComponentPropsWithoutRef<typeof Root> &
    VariantProps<typeof labelVariants> & {
      required?: boolean;
    }
>(({ className, children, required, ...props }, ref) => (
  <Root ref={ref} className={cn(labelVariants(), className)} {...props}>
    {children}
    {required && <span className="text-red"> *</span>}
  </Root>
));
Label.displayName = Root.displayName;

export { Label };
